<div class="dialog-title">Update Unit Status</div>

<div class="dialog-description">Select status to update the unit status.</div>

<mat-form-field>
  <mat-label>Select Status</mat-label>
  <mat-select>
    <option value="volvo">Available</option>
    <option value="saab">Not Available</option>
  </mat-select>
</mat-form-field>

<div class="dialog-buttons">
  <button mat-button color="primary" [mat-dialog-close]="false">Cancel</button>
  <button mat-button color="primary" [mat-dialog-close]="false">Save</button>
</div>
